import { Dispatch } from 'redux';

import { IApprovalStayMealData } from 'src/actions/search';
import { IClassStayMealInfo } from 'src/containers/CareerStayMeal';
import * as Actions from '../actions/imstat';
import { IUserAttr } from '../actions/session';
import AbstractScenario from './AbstractScenario';

/** 申請変更情報取得シナリオ用パラメータ */
export interface IFetchChangeApplicationParam {
	careerID: string;
	classID: string;
	userAttr: IUserAttr;
}

/** 申請取消シナリオ用パラメータ */
export interface ICancelApplicationParam {
	aplType: string;
	careerID: string;
	classID: string;
	userAttr: IUserAttr;
}

/** 実績申請情報取得シナリオ用パラメータ */
export interface IFetchActResultApplicationDataParam {
	careerID: string;
	classID: string;
	nitteiOnlyFlg: boolean;
	userAttr: IUserAttr;
}

/** 実績申請シナリオ用パラメータ */
export interface ISaveActResultApplicationParam {
	careerID: string;
	classID: string;
	application: Actions.IActResultApplication;
	applyFlg: boolean;
	userAttr: IUserAttr;
}

/** 受講取消情報取得シナリオ用パラメータ */
export interface IFetchLectureCancelDataParam {
	careerID: string;
	classID: string;
	curriculumFlg: boolean;
	userAttr: IUserAttr;
}

/** 受講取消シナリオ用パラメータ */
export interface ISaveLectureCancelParam {
	careerID: string;
	classID: string;
	application: Actions.IApplication;
	curriculumFlg: boolean;
	userAttr: IUserAttr;
}

/** 進捗状況情報取得シナリオ用パラメータ */
export interface IFetchTrainingProgressDataParam {
	careerID: string;
	classID: string;
	userAttr: IUserAttr;
}

/** 申請内容情報取得シナリオ用パラメータ */
export interface IFetchApplicationStatusDataParam {
	aplType: string;
	careerID: string;
	classID: string;
	curriculumFlg: number;
	userAttr: IUserAttr;
}

/** テストアンケート履歴取得シナリオ用パラメータ */
export interface IFetchQuestionnaireHistoryParam {
	careerId: string;
	classId: string;
}

/** カリキュラム内容取得シナリオ用パラメータ */
export interface IFetchCurriculumContentParam {
	careerID: string;
	userAttr: IUserAttr;
}

/** 実績参照情報取得シナリオ用パラメータ */
export interface IFetchActResultReferenceParam {
	careerID: string;
	classID: string;
	seq: string;
	reasonCode: string;
	imstatListStatusId: number;
	userAttr: IUserAttr;
}

/**
 * 受講・実績情報シナリオファクトリ
 */
export default class ImstatScenarioFactory {
	/**
	 * 実施中eラーニング取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createFetchOnGoingELearning(
		dispatch: Dispatch,
		token: string,
		onlyQualificationDispalyFlg: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(arg: IUserAttr) {
				const s = ImstatScenarioFactory.createDoFetchOnGoingELearning(
					dispatch,
					token,
					onlyQualificationDispalyFlg
				);
				return s.runThen(arg, (data: any) => {
					this.dispatch(
						Actions.setImstatOnGoingELearningData({
							data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実施中eラーニング取得シナリオ作成実処理
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchOnGoingELearning(
		dispatch: Dispatch,
		token: string,
		onlyQualificationDispalyFlgItem?: string
	) {
		let onlyQualificationDispalyFlg = '0';
		if (onlyQualificationDispalyFlgItem) {
			onlyQualificationDispalyFlg = onlyQualificationDispalyFlgItem;
		}
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(userAttr: IUserAttr) {
				// データ取得
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: '10',
					lang: userAttr.lang,
					locale: userAttr.locale,
					onlyQualificationDispalyFlg,
					userId: userAttr.userId,
				};
				return this.read('per_imstat_OngELBlockCollection', param).then(
					data =>
						data.onGoingELGridList as Actions.IOnGoingELearning[]
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実施中集合研修取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createFetchOnGoingGroupTraining(
		dispatch: Dispatch,
		token: string,
		onlyQualificationDispalyFlg: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(arg: IUserAttr) {
				const s = ImstatScenarioFactory.createDoFetchOnGoingGroupTraining(
					dispatch,
					token,
					onlyQualificationDispalyFlg
				);
				return s.runThen(arg, (data: any) => {
					this.dispatch(
						Actions.setImstatOnGoingGroupTrainingData({
							data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実施中集合研修取得シナリオ作成実処理
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchOnGoingGroupTraining(
		dispatch: Dispatch,
		token: string,
		onlyQualificationDispalyFlgItem?: string
	) {
		let onlyQualificationDispalyFlg = '0';
		if (onlyQualificationDispalyFlgItem) {
			onlyQualificationDispalyFlg = onlyQualificationDispalyFlgItem;
		}
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(userAttr: IUserAttr) {
				// データ取得
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: '10',
					lang: userAttr.lang,
					locale: userAttr.locale,
					onlyQualificationDispalyFlg,
					userId: userAttr.userId,
				};
				return this.read('per_imstat_OngGTBlockCollection', param).then(
					data =>
						data.onGoingGTGridList as Actions.IOnGoingGroupTraining[]
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実施中集合研修取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createFetchOnGoingDistanceLearning(
		dispatch: Dispatch,
		token: string,
		onlyQualificationDispalyFlg: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(arg: IUserAttr) {
				const s = ImstatScenarioFactory.createDoFetchOnGoingDistanceLearning(
					dispatch,
					token,
					onlyQualificationDispalyFlg
				);
				return s.runThen(arg, (data: any) => {
					this.dispatch(
						Actions.setImstatOnGoingDistanceLearningData({
							data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実施中集合研修取得シナリオ作成実処理
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchOnGoingDistanceLearning(
		dispatch: Dispatch,
		token: string,
		onlyQualificationDispalyFlgItem?: string
	) {
		let onlyQualificationDispalyFlg = '0';
		if (onlyQualificationDispalyFlgItem) {
			onlyQualificationDispalyFlg = onlyQualificationDispalyFlgItem;
		}
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(userAttr: IUserAttr) {
				// データ取得
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: '10',
					lang: userAttr.lang,
					locale: userAttr.locale,
					onlyQualificationDispalyFlg,
					userId: userAttr.userId,
				};
				return this.read('per_imstat_OngDLBlockCollection', param).then(
					data =>
						data.onGoingDLGridList as Actions.IOnGoingDistanceLearning[]
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実施中カリキュラム取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createFetchOnGoingCurriculum(
		dispatch: Dispatch,
		token: string,
		onlyQualificationDispalyFlg: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(arg: IUserAttr) {
				const s = ImstatScenarioFactory.createDoFetchOnGoingCurriculum(
					dispatch,
					token,
					onlyQualificationDispalyFlg
				);
				return s.runThen(arg, (data: any) => {
					this.dispatch(
						Actions.setImstatOnGoingCurriculumData({
							data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実施中カリキュラム取得シナリオ作成実処理
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchOnGoingCurriculum(
		dispatch: Dispatch,
		token: string,
		onlyQualificationDispalyFlgItem?: string
	) {
		let onlyQualificationDispalyFlg = '0';
		if (onlyQualificationDispalyFlgItem) {
			onlyQualificationDispalyFlg = onlyQualificationDispalyFlgItem;
		}
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(userAttr: IUserAttr) {
				// データ取得
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: '10',
					lang: userAttr.lang,
					locale: userAttr.locale,
					onlyQualificationDispalyFlg,
					userId: userAttr.userId,
				};
				return this.read(
					'per_imstat_OngCULBlockCollection',
					param
				).then(
					data => data.onGoingCULGridList as Actions.ICurriculum[]
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績eラーニング取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createFetchResultELearning(
		dispatch: Dispatch,
		token: string,
		onlyQualificationDispalyFlg: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(arg: IUserAttr) {
				const s = ImstatScenarioFactory.createDoFetchResultELearning(
					dispatch,
					token,
					onlyQualificationDispalyFlg
				);
				return s.runThen(arg, (data: any) => {
					this.dispatch(
						Actions.setImstatResultELearningData({
							data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績eラーニング取得シナリオ作成実処理
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchResultELearning(
		dispatch: Dispatch,
		token: string,
		onlyQualificationDispalyFlgItem?: string
	) {
		let onlyQualificationDispalyFlg = '0';
		if (onlyQualificationDispalyFlgItem) {
			onlyQualificationDispalyFlg = onlyQualificationDispalyFlgItem;
		}
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(userAttr: IUserAttr) {
				// データ取得
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: '10',
					lang: userAttr.lang,
					locale: userAttr.locale,
					onlyQualificationDispalyFlg,
					userId: userAttr.userId,
				};
				return this.read(
					'per_imstat_RsltELBlockCollection',
					param
				).then(
					data => data.resultELGridList as Actions.IResultELearning[]
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績集合研修取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createFetchResultGroupTraining(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(arg: IUserAttr) {
				const s = ImstatScenarioFactory.createDoFetchResultGroupTraining(
					dispatch,
					token
				);
				return s.runThen(arg, (data: any) => {
					this.dispatch(
						Actions.setImstatResultGroupTrainingData({
							data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績集合研修取得シナリオ作成実処理
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchResultGroupTraining(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(userAttr: IUserAttr) {
				// データ取得
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: '10',
					lang: userAttr.lang,
					locale: userAttr.locale,
					userId: userAttr.userId,
				};
				return this.read(
					'per_imstat_RsltGTBlockCollection',
					param
				).then(
					data =>
						data.resultGTGridList as Actions.IResultGroupTraining[]
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績集合研修取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createFetchResultDistanceLearning(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(arg: IUserAttr) {
				const s = ImstatScenarioFactory.createDoFetchResultDistanceLearning(
					dispatch,
					token
				);
				return s.runThen(arg, (data: any) => {
					this.dispatch(
						Actions.setImstatResultDistanceLearningData({
							data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績集合研修取得シナリオ作成実処理
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchResultDistanceLearning(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(userAttr: IUserAttr) {
				// データ取得
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: '10',
					lang: userAttr.lang,
					locale: userAttr.locale,
					userId: userAttr.userId,
				};
				return this.read(
					'per_imstat_RsltDLBlockCollection',
					param
				).then(
					data =>
						data.resultDLGridList as Actions.IResultDistanceLearning[]
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績カリキュラム取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createFetchResultCurriculum(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(arg: IUserAttr) {
				const s = ImstatScenarioFactory.createDoFetchResultCurriculum(
					dispatch,
					token
				);
				return s.runThen(arg, (data: any) => {
					this.dispatch(
						Actions.setImstatResultCurriculumData({
							data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績カリキュラム取得シナリオ作成実処理
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchResultCurriculum(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IUserAttr> {
			protected process(userAttr: IUserAttr) {
				// データ取得
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: '10',
					lang: userAttr.lang,
					locale: userAttr.locale,
					userId: userAttr.userId,
				};
				return this.read(
					'per_imstat_RsltCULBlockCollection',
					param
				).then(data => data.resultCULGridList as Actions.ICurriculum[]);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 申請変更情報取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createFetchChangeApplication(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchChangeApplicationParam
		> {
			protected process(arg: IFetchChangeApplicationParam) {
				const param = {
					accessType: '10',
					careerID: arg.careerID,
					classID: arg.classID,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					userId: arg.userAttr.userId,
				};
				return this.read(
					'per_imstat_StReqChangeBlockModel',
					param
				).then(data => {
					dispatch(
						Actions.setChangeApplicationData({
							data,
						})
					);
					if (data.staymealList) {
						const staymealList: Actions.ICancelStayMeal[] = data.staymealList.map(
							(item: Actions.ICancelStayMeal) => ({
								UID: item.UID,
								careerID: item.careerID,
								classID: item.classID,
								comment: item.comment,
								date: item.date,
								executionDate: item.executionDate,
								mealAfternoonFlg: item.mealAfternoonFlg,
								mealEveningFlg: item.mealEveningFlg,
								mealMorningFlg: item.mealMorningFlg,
								sexFlg: item.sexFlg,
								smokingFlg: item.smokingFlg,
								stayFlg: item.stayFlg,
								week: item.week,
							})
						);
						dispatch(
							Actions.setCancelStayMealData({
								cancelStayMealData: staymealList,
							})
						);
					}
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 申請変更シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createSaveChangeApplication(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			Actions.IApplicationStayMeal
		> {
			protected process(appl: Actions.IApplicationStayMeal) {
				const param = {
					accessType: '10',
					approve1ActiveFlg: !appl.application.approve1List
						? false
						: true,
					approve2ActiveFlg: !appl.application.approve2List
						? false
						: true,
					approve4ActiveFlg: !appl.application.approve4List
						? false
						: true,
					...appl.application,
					approve1List: null,
					approve2List: null,
					approve4List: null,
					stayMealData: appl.stayMealData.map(
						(
							item: IApprovalStayMealData
						): {
							[key: string]: string | boolean | null | any;
						} => ({
							UID: item.UID,
							careerID: item.careerID,
							classID: item.classID,
							comment: item.Comment,
							sexFlg: item.SexFlg,
							smokingFlg: item.SmokingFlg,
							stayMealDateList: item.StayMealDateList.map(
								(
									it: IClassStayMealInfo
								): {
									[key: string]: string | boolean | null;
								} => ({
									executionDate: it.ExecutionDate,
									mealAfternoonFlg: it.MealAfternoonFlg,
									mealEveningFlg: it.MealEveningFlg,
									mealMorningFlg: it.MealMorningFlg,
									stayFlg: it.StayFlg,
								})
							),
						})
					),
				};
				return this.update(
					'per_imstat_StReqChangeBlockModel',
					param
				).then(data => {
					dispatch(
						Actions.showChangeApplicationDialog({
							dialogOpen: true,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 申請取消シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createCancelApplication(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			ICancelApplicationParam
		> {
			protected process(arg: ICancelApplicationParam) {
				const param = {
					accessType: '10',
					aplType: arg.aplType,
					careerID: arg.careerID,
					classID: arg.classID,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					userId: arg.userAttr.userId,
				};
				return this.create(
					'per_imstat_ReqCancelBlockModel',
					param
				).then(data => {
					dispatch(
						Actions.showCancelApplicationDialog({
							dialogOpen: true,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績申請情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchActResultApplicationData(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchActResultApplicationDataParam
		> {
			protected process(arg: IFetchActResultApplicationDataParam) {
				const param = {
					accessType: '10',
					careerID: arg.careerID,
					classID: arg.classID,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					nitteiOnlyFlg: arg.nitteiOnlyFlg,
					userId: arg.userAttr.userId,
				};
				return this.read('per_imstat_ActResApBlockModel', param).then(
					data => {
						if (data.startDate) {
							data.startDate =
								data.startDate.split(' ')[0] + ' ' + '00:00';
						}
						if (data.endDate) {
							data.endDate =
								data.endDate.split(' ')[0] + ' ' + '23:59';
						}
						if (data.validDate) {
							data.validDate =
								data.validDate.split(' ')[0] + ' ' + '23:59';
						}
						dispatch(
							Actions.setActResultApplicationData({
								backup: true,
								data,
							})
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績申請シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createSaveActResultApplication(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			ISaveActResultApplicationParam
		> {
			protected process(arg: ISaveActResultApplicationParam) {
				const convData = JSON.parse(JSON.stringify(arg.application));
				const param = {
					accessType: '10',
					actionKind: 'update',
					applyFlg: arg.applyFlg,
					careerID: arg.careerID,
					classID: arg.classID,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					userId: arg.userAttr.userId,
					...convData,
				};
				// if (param.startDate) {
				//     param.startDate = InputCheck.convertDate(param.startDate);
				// }
				// if (param.endDate) {
				//     param.endDate = InputCheck.convertDate(param.endDate);
				// }
				// if (param.validDate) {
				//     param.validDate = InputCheck.convertDate(param.validDate);
				// }

				return this.update('per_imstat_ActResApBlockModel', param).then(
					data => {
						dispatch(
							Actions.showActResultApplicationDialog({
								applySuccessDialogOpen: arg.applyFlg,
								saveSuccessDialogOpen: !arg.applyFlg,
							})
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 受講取消情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchLectureCancelData(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchLectureCancelDataParam
		> {
			protected process(arg: IFetchLectureCancelDataParam) {
				const param = {
					accessType: '10',
					careerID: arg.careerID,
					classID: arg.classID,
					curriculumFlg: arg.curriculumFlg,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					userId: arg.userAttr.userId,
				};
				return this.read('per_imstat_StCancelBlockModel', param).then(
					data => {
						dispatch(
							Actions.setLectureCancelData({
								data,
							})
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 受講取消シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createSaveLectureCancel(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			ISaveLectureCancelParam
		> {
			protected process(arg: ISaveLectureCancelParam) {
				const convData = JSON.parse(JSON.stringify(arg.application));
				const param = {
					...convData,
					accessType: '10',
					actionKind: 'update',
					careerID: arg.careerID,
					classID: arg.classID,
					curriculumFlg: arg.curriculumFlg,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					userId: arg.userAttr.userId,
				};
				return this.update('per_imstat_StCancelBlockModel', param).then(
					data => {
						dispatch(
							Actions.showLectureCancelDialog({
								dialogOpen: true,
							})
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 進捗状況情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchTrainingProgressData(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchTrainingProgressDataParam
		> {
			protected process(arg: IFetchTrainingProgressDataParam) {
				this.dispatch(
					Actions.setTrainingProgress({
						trainingProgress: 'loading',
					})
				);
				const param = {
					accessType: '10',
					careerID: arg.careerID,
					classID: arg.classID,
					userId: arg.userAttr.userId,
				};
				return this.read(
					'per_imstat_TrainingProgressBlockModel',
					param
				).then(trainingProgress => {
					this.dispatch(
						Actions.setTrainingProgress({
							trainingProgress,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 申請内容情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchApplicationStatusData(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchApplicationStatusDataParam
		> {
			protected process(arg: IFetchApplicationStatusDataParam) {
				const param = {
					accessType: '10',
					aplType: arg.aplType,
					careerID: arg.careerID,
					classID: arg.classID,
					curriculumFlg: arg.curriculumFlg,
					userId: arg.userAttr.userId,
				};
				return this.read(
					'per_imstat_ApplicationStatusBlockModel',
					param
				).then(data => {
					dispatch(
						Actions.setApplicationStatusData({
							data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * テストアンケート履歴取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchQuestionnaireHistory(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchQuestionnaireHistoryParam
		> {
			protected process(arg: IFetchQuestionnaireHistoryParam) {
				const param = {
					careerId: arg.careerId,
					classId: arg.classId,
				};
				return this.read(
					'per_career_TestEnqueteListBlockModel',
					param
				).then(data => {
					dispatch(
						Actions.setQuestionnaireHistoryData({
							data: data.testEnqueteList,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実施中カリキュラム内容取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchOnGoingCurriculumContent(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchCurriculumContentParam
		> {
			protected process(arg: IFetchCurriculumContentParam) {
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: '10',
					careerID: arg.careerID,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					userId: arg.userAttr.userId,
				};
				return this.read(
					'per_imstat_OngCUDListBlockCollection',
					param
				).then(data => {
					dispatch(
						Actions.setCurriculmContentData({
							data: data.onGoingCUDGridList,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績カリキュラム内容取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchResultCurriculumContent(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchCurriculumContentParam
		> {
			protected process(arg: IFetchCurriculumContentParam) {
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: '10',
					careerID: arg.careerID,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					userId: arg.userAttr.userId,
				};
				return this.read(
					'per_imstat_RsltCUDListBlockCollection',
					param
				).then(data => {
					dispatch(
						Actions.setCurriculmContentData({
							data: data.resultCUDGridList,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績参照情報取得シナリオ作成
	 * @static
	 * @param {Dispatch} dispatch
	 * @param {string} token
	 * @returns
	 * @memberof ImstatScenarioFactory
	 */
	public static createFetchActResultReference(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchActResultReferenceParam
		> {
			protected process(arg: IFetchActResultReferenceParam) {
				const param = {
					accessType: '10',
					careerID: arg.careerID,
					classID: arg.classID,
					imstatListStatusId: arg.imstatListStatusId,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					reasonCode: arg.reasonCode,
					seq: arg.seq,
					userId: arg.userAttr.userId,
				};
				return this.read('per_imstat_ActResRefBlockModel', param).then(
					data => {
						dispatch(
							Actions.setActResultReferenceData({
								data,
							})
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実施状況画面初期表示設定取得シナリオ作成
	 * @static
	 * @param {Dispatch} dispatch
	 * @param {string} token
	 */
	public static createFetchDefaultDisplaySetting(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process({}) {
				return this.read('per_imstat_DisplaySettingBlockModel').then(
					data => {
						dispatch(
							Actions.setImstatDefaultDisplaySettings({
								defaultDisplayFormat: data.defaultDisplayFormat,
								defaultDisplayTarget: data.defaultDisplayTarget,
							})
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/ImstatScenarioFactory.ts